import React, { useCallback } from 'react';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';

import { IconNotConnected } from '@/assets/connect';
import { Card, Button } from 'components';
import { useCurrentAddressInfo } from 'hooks';
import { login } from 'utils';

import style from './index.module.css';

interface NotConnectedProps {
  title?: string;
  buttonText?: string;
  className?: string;
  onClick?(): void;
  customHeader?: React.ReactNode;
  withIcon?: boolean;
  shadow?: boolean;
}

export const NotConnected = ({
  title,
  buttonText,
  className,
  onClick,
  customHeader,
  withIcon,
  shadow,
}: NotConnectedProps) => {
  const { t } = useTranslation();
  const { address, isVerified } = useCurrentAddressInfo();

  const handleClick = useCallback(async () => {
    if (onClick) {
      return onClick();
    }

    login();
    // regenerator hanleClick while isVerified changed
    // eslint-disable-next-line
  }, [address, onClick, isVerified]);

  return (
    <Card className={cx(style.container, className)} shadow={shadow}>
      {customHeader}
      {withIcon ? <img src={IconNotConnected} alt="" className={style.notConnectedIcon} /> : null}
      {title || t('NotConnected.1vhxgh')}
      <Button className={style.connectBtn} type="primary" onClick={handleClick} shadow>
        {buttonText || (address ? 'Verify account' : t('UserInfoBtn.1a3u91l'))}
      </Button>
    </Card>
  );
};

export default NotConnected;
